import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface GatewayIsAnnouncedResult {
  success: boolean;
  status?: number;
  error?: string;
  isAnnounced?: boolean;
  isOnboarded?: boolean;
}

export const gatewayIsAnnouncedUseCase = async (
  onboardingKey: string,
): Promise<GatewayIsAnnouncedResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext?.customerNamespace;

    const response = await apiUseCases.postGatewayIsAnnounced(
      namespace,
      onboardingKey,
    );

    return {
      success: true,
      status: response.status,
      isAnnounced: response.data.is_announced,
      isOnboarded: response.data.is_onboarded,
    };
  } catch (error) {
    const parsed = parseAxiosApiError(
      error,
      "Failed to check gateway announcement.",
    );

    return {
      success: false,
      status: parsed.status,
      error: parsed.message,
    };
  }
};
